module.exports = __webpack_public_path__ + "assets/25109c14365682bc41970cc65c730989.png";